import {
  GET_BUSINESSRULES_FLEXIBILITY,
  GET_CREATE_FLEXIBILITY_DATA,
  SET_HOLIDAYS_OR_SEASONS,
  FILE_UPLOAD_PAGE
} from "../constants/action-types";

let initialState = {
  businessRulesFlexibility: [],
  unknownRulesData: [],
  holidaysOrSeasons: "",
  isPageRefreshed: false,
};

export let businessRulesReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUSINESSRULES_FLEXIBILITY:
      return {
        ...state,
        businessRulesFlexibility: action.payload,
      };
    case GET_CREATE_FLEXIBILITY_DATA:
      return {
        ...state,
        unknownRulesData: action.payload,
      };
    case SET_HOLIDAYS_OR_SEASONS:
      return {
        ...state,
        holidaysOrSeasons: action.payload
      };
    case FILE_UPLOAD_PAGE:
      return {
        ...state,
        isPageRefreshed: action.payload
      }
    default:
      return state;
  }
};
